module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "error-snackbar"
  }, [_c('v-snackbar', {
    attrs: {
      "timeout": 6000,
      "top": ""
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.text) + "\n    "), _c('v-btn', {
    staticClass: "pink--text",
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ce8ef646","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/@sdgsystems/vue-common/components/ErrorSnackbar.vue
// module id = 457
// module chunks = 1